class SeedMapItem {
  constructor (seed, poolNumber, poolFinish) {
    this.seed = seed
    this.poolNumber = poolNumber
    this.poolFinish = poolFinish
  }
}

function createMap (pools, exclude, powerPools) {
  const teams = []
  pools = [...pools].sort((a, b) => a.number - b.number)

  const power = pools.slice(0, powerPools)
  const capture = pools.slice(powerPools)

  if (power.length > 0) {
    teams.push(...getPowerPoolMap(power, exclude))
  }

  const start = teams.length > 0 ? Math.max(...teams.map(m => m.seed)) + 1 : 1

  if (capture.length > 0) {
    teams.push(...getCaptureSeedMap(capture, exclude, start))
  }

  return teams
}

function getCaptureSeedMap (pools, exclude, start = 1) {
  const teams = []
  const teamCount = pools.reduce((sum, pool) =>
    sum + pool.teams.filter(team => !exclude.includes(team.tournamentTeamId)).length, 0
  )

  pools = [...pools].sort((a, b) => a.number - b.number)

  let seed = start
  const largestPoolN = Math.max(...pools.map(pool =>
    pool.teams.filter(team => !exclude.includes(team.tournamentTeamId)).length
  ))

  let loop = 1
  while (teams.length < teamCount) {
    for (const pool of pools) {
      const validTeams = pool.teams.filter(team => !exclude.includes(team.tournamentTeamId)).length
      if (validTeams >= loop) {
        teams.push(new SeedMapItem(
          seed++,
          pool.number,
          loop
        ))
      }
    }
    loop++

    if (!(loop === largestPoolN && isOdd(largestPoolN))) {
      pools.reverse()
    }
  }

  return teams
}

function getPowerPoolMap (pools, exclude) {
  const teams = []
  pools = [...pools].sort((a, b) => a.number - b.number)

  let seed = 1
  for (const pool of pools) {
    const validTeams = pool.teams.filter(team => !exclude.includes(team.tournamentTeamId))
    for (let i = 0; i < validTeams.length; i++) {
      teams.push(new SeedMapItem(
        seed++,
        pool.number,
        i + 1
      ))
    }
  }

  return teams
}

function isOdd (num) {
  return num % 2 !== 0
}

export { createMap }
